import * as yup from 'yup'
import { BRANCH_TIMEZONES } from '../../constants'

export const Schema = (branch) => {
  const { propelIntegrationEnabled } = branch || {};
  const isPropelEnabled = !!propelIntegrationEnabled;
  const schema = {
    pharmacyDetails: {
      'Name': { fieldName: 'addressLine1', field: 'pharmacy_name', validation: yup.string().required() },
      'Address Line 1': { fieldName: 'addressLine1', field: 'address.addressLine1', validation: yup.string().required() },
      'Postcode': { fieldName: 'postcode', field: 'address.postcode', validation: yup.string().required() },
      'City': { fieldName: 'city', field: 'address.city', validation: yup.string().required() },
      'Country': {
        fieldName: 'country',
        type: 'select',
        values: ['England', 'Scotland', 'Wales', 'Northern Ireland', 'Canada'],
        field: 'address.country',
        defaultValue: 'England',
        validation: yup.string().required()
      },
      'Timezone': {
        type: 'select',
        values: BRANCH_TIMEZONES,
        field: 'timezone',
        defaultValue: 'Europe/London',
        validation: yup.string().required()
      },
      'Propel Integration': {
        type: 'switch',
        field: 'propelIntegrationEnabled',
        defaultValue: false,
        validation: yup.boolean()
      }
    },
    pharmacyContact: {
      'First Name': { field: 'primaryContact.firstName', validation: yup.string().required() },
      'Last Name': { field: 'primaryContact.lastName', validation: yup.string().required() },
      'Pharmacist\'s email': { field: 'primaryContact.email', validation: yup.string().email().required() },
      'Telephone': { field: 'telephone', validation: yup.string().required() }
    }
  }

  if (isPropelEnabled) {
    schema.pharmacyDetails['External Pharmacy ID'] = {
      field: 'externalPharmacyId',
      validation: yup.string().required()
    }
  }

  const getValue = (obj, path) => path.split('.').reduce((acc, part) => acc && acc[part], obj);

  const bindValues = (section) => {
    Object.keys(section).forEach(key => {
      const fieldDef = section[key];
      const val = getValue(branch, fieldDef.field);
      if (val !== undefined) fieldDef.value = val;
    });
    return section;
  }

  bindValues(schema.pharmacyDetails);
  bindValues(schema.pharmacyContact);

  return schema
}
